import React, { useState, useEffect, useMemo, useRef } from "react";
import Menu from "../chat/Menu";
import "./aicopilot.css";
import backup from "../../Images/backup.png";
import plus from "../../Images/plus1.png";
import send from "../../Images/send.png";
import bell from "../../Images/ai-bell.png";
import search from "../../Images/search-big.jpg";
import { Header } from "../../components/Header/Header";
import axios from "axios";
import { v4 as uuidv4 } from "uuid"; // Importing the UUID function
import { toast } from "../../utils/appToast";
import uploadlogo from "../../Images/after-upload.png";
import blueai from "../../Images/blue-ai.png";
import findImage from "../../Images/find_in_page.png";
import find from "../../Images/find.jpg";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FileSuccessfullyUploaded } from "./FileSuccessfullyUploaded";
import AICopilotIcon from "../../Images/ai-copiot-icon.svg";
import UploadIcon from "../../Images/upload-icon.svg";
import summarizeIcon from "../../Images/summarizeText-icon.svg";
import arrowForward from "../../Images/arrow_forward.svg";
import InvoiceIcon from "../../Images/invoice-icon.svg";
import SpreadsheetIcon from "../../Images/spreadsheet-icon.svg";
import DocumentUploadModal from "../AI_Copilot/uploadDocument.jsx";
import arrowForward2 from "../../Images/arrow_forward-2.svg";
import UploadModal from "../Contract/UploadModal.jsx";
import ExplorePrompt from "./explorePromptModal.jsx";
import ContractSearch from "../../components/searchContracts.jsx";
import SearchDocuments from "../../components/searchDocuments.jsx";
import SearchSpreadsheet from "../../components/searchSpreadsheet.jsx";
import SearchInvoice from "../../components/searchInvoices.jsx";
import { useInputField } from "./InputFieldContext.js";
import PromptChat from "./PromptChat.jsx";
import ChatHistory from "./ChatHistory.jsx";

import Cookies from "js-cookie";

import api from "../chat/api";
import { getFreshAccessToken } from "../chat/api";

export const AIcopilot = ({ isMenuOpen }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });
  const [chatInput, setChatInput] = useState("");
  const [selectedDoc, setSelectedDoc] = useState(null); // Track selected document
  const [clickedCardIndex, setClickedCardIndex] = useState(null); // Tracks which card is clicked
  const [inputValue, setInputValue] = useState("");
  const [isChatActive, setIsChatActive] = useState(false);
  const [showContractSearch, setShowContractSearch] = useState(false); // Tracks if ContractSearch should be shown
  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [files, setFiles] = useState([]);
  const [folders, setFolders] = useState([]);
  const [clickedCards, setClickedCards] = useState([]);
  const [status, setStatus] = useState("");
  const [progress, setProgress] = useState(0);
  const [apiResponse, setApiResponse] = useState(null);
  const [fileData, setFileData] = useState(null);
  const [contractKey, setContractKey] = useState("");
  const [contractUrl, setContractUrl] = useState("");
  const [documentType, setdocumentType] = useState("");
  const [selectedDocumentName, setselectedDocumentName] = useState("");
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [PromptChatInput, setPromptChatInput] = useState("");
  const [enrichedPrompt, setEnrichedPrompt] = useState("");

  // const [isModalOpen, setModalOpen] = useState(false);
  const [token, setToken] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPromptModalOpen, setIsPromptModalOpen] = useState(false);
  const { appendButton } = useInputField(); // Access the shared state
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [isLoadingResponse, setIsLoadingResponse] = useState(false);
  const [finalResponse, setFinalResponse] = useState("");
  const [generatedQuestions, setGeneratedQuestions] = useState([]);
  const [selectedPromptSection, setSelectedPromptSection] = useState(null);
  const [displayName, setDisplayName] = useState("");
  // 1) Initialize from localStorage on mount
  // 2) Whenever isPromptChatVisible changes, store it in localStorage
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [uploadFiles, setUploadFiles] = useState(null);
  const fileInputRef = useRef(null);

  const [isPromptChatVisible, setIsPromptChatVisible] = useState(() => {
    const savedValue = localStorage.getItem("isPromptChatVisible");
    return savedValue ? JSON.parse(savedValue) : false;
    // You can default to 'true' if you want the chat to be open by default.
  });

  useEffect(() => {
    // Save to localStorage whenever isPromptChatVisible changes
    localStorage.setItem(
      "isPromptChatVisible",
      JSON.stringify(isPromptChatVisible)
    );
  }, [isPromptChatVisible]);

  const [chatId, setChatId] = useState(() => {
    const savedChatId = localStorage.getItem("chatId");
    return savedChatId || null;
  });

  useEffect(() => {
    if (chatId) {
      localStorage.setItem("chatId", chatId);
    } else {
      localStorage.removeItem("chatId");
    }
  }, [chatId]);

  /// chat history

  const [chatHistory, setChatHistory] = useState([]);
  const [selectedChatHistory, setSelectedChatHistory] = useState([]);
  const [isLoadingChatHistory, setIsLoadingChatHistory] = useState(false);
  const [isLoadingDocs, setIsLoadingDocs] = useState(false);

  const handleUploadFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    if (selectedFiles.length === 0) return;

    setUploadFiles(selectedFiles); // Sets files for UploadModal
    setIsUploadModalOpen(true); // Opens the UploadModal
  };

  // Fetch chat history
  // useEffect(() => {
  const fetchChatHistory = async () => {
    setIsLoadingChatHistory(true);

    try {
      const response = await api.get(`api/v1/copilot/chats/`);
      setChatHistory(response.data.chat_sessions);
    } catch (error) {
      console.error("Error fetching chat history:", error);
      setChatHistory([]);
    } finally {
      setIsLoadingChatHistory(false);
    }
  };

  const [showChatHistory, setShowChatHistory] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const toggleChatHistory = async () => {
    setIsOpen(!isOpen);
    setIsNewSession(false);

    if (!showChatHistory) {
      await fetchChatHistory();
    }

    // setShowChatHistory((prevState) => !prevState);
  };

  useEffect(() => {
    fetchChatHistory();
  }, []);

  const handleChatSelection = (chatIdFromList, messages) => {
    setChatId(chatIdFromList);

    setSelectedChatHistory(messages);
    if (chatIdFromList) {
      setIsPromptChatVisible(true);
    } else {
      setIsPromptChatVisible(false);
    }

    setIsOpen(false);
  };
  useEffect(() => {}, [selectedChatHistory]);

  useEffect(() => {}, [selectedChatHistory]);

  const handlePromptSelection = (prompt, sectionName) => {
    setChatInput(prompt);
    setSelectedPromptSection(sectionName);
    setShowContractSearch(true);

    if (selectedDoc) {
      setSelectedDoc({
        key: selectedDoc.key,
        name: selectedDoc.name,
        type: selectedDoc.type,
        url: selectedDoc.url,
      });
    }
  };

  const handleFocus = () => {
    setIsChatActive(true);
  };
  const handleBlur = () => {
    // Optionally, you can set the chat inactive on blur if the input is empty.
    if (chatInput.trim() === "") {
      setIsChatActive(false);
    }
  };
  // Function to handle card click
  const handleCardClick = (message, index) => {
    setChatInput(message);
    setIsChatActive(true);
    if (inputRef.current) {
      inputRef.current.focus();
    }
    setClickedCardIndex(index);
    setShowContractSearch(true);
    if (!isNewSession) {
      setIsNewSession(true);
    } // Determine the section based on the index
    if (index === 0) {
      setSelectedPromptSection("Contracts"); // Card 1 relates to Contracts
    } else if (index === 1) {
      setSelectedPromptSection("Invoices"); // Card 2 relates to Invoices
    } else {
      setSelectedPromptSection("Invoices"); // Card 2 relates to Invoices
    }
  };

  /// states to track selection of object and values...
  // 1) State for dynamic dropdown
  const [showObjects, setShowObjects] = useState(false);
  const [showValues, setShowValues] = useState(false);
  const [filteredObjects, setFilteredObjects] = useState([]);
  const [filteredValues, setFilteredValues] = useState([]);
  const [selectedObject, setSelectedObject] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [spreadsheet, setSpreadsheet] = useState([]);
  const [showAtDropdown, setShowAtDropdown] = useState(false);
  const [filteredAtOptions, setFilteredAtOptions] = useState([]);

  // 2) Object-to-values mapping
  const objectOptions = useMemo(
    () => ({
      Documents: documents.map((doc) => ({
        id: doc.id,
        name: doc.name,
        url: doc.url,
        type: "document",
      })),
      Contracts: contracts.map((contract) => ({
        id: contract.id,
        name: contract.name,
        url: contract.url,
        type: "contract",
      })),
      Invoices: invoices.map((invoice) => ({
        id: invoice.id,
        name: invoice.name,
        url: invoice.url,
        type: "invoice",
      })),
      Spreadsheets: spreadsheet.map((doc) => ({
        id: doc.id,
        name: doc.name,
        url: doc.url,
        type: "spreadsheet",
      })),
    }),
    [documents, contracts, invoices, spreadsheet]
  ); // Ensure it updates when API data changes

  const objectIcons = {
    Documents: <img src="/ai-object-document-icon.svg" alt="Document Icon" />,
    Contracts: <img src="/ai-object-contract-icon.svg" alt="contracts Icon" />,
    Invoices: <img src="/ai-object-invoice-icon.svg" alt="Invoice Icon" />,
    Spreadsheets: (
      <img src="/ai-object-spread-icon.svg" alt="spreadsheet Icon" />
    ),
  };

  const fetchAllDocuments = async () => {
    if (documents.length || contracts.length || invoices.length) {
      return;
    }

    setIsLoadingDocs(true);
    const url = `api/v1/copilot/all-docs/`;

    try {
      const response = await api.get(url, {});

      // FIXED: Extract categories correctly from response.data.all_documents
      const {
        contracts = [],
        invoices = [],
        documents = [],
        spreadsheet = [],
      } = response.data.all_documents || {};

      setContracts(
        contracts.map((doc) => ({
          id: doc.id, // ✅ preserve id
          key: doc.key,
          name: doc.name,
          url: doc.url,
          type: "contract",
          document_type: doc.document_type,
        }))
      );

      setInvoices(
        invoices.map((doc) => ({
          id: doc.id,
          key: doc.key,
          name: doc.name,
          url: doc.url,
          type: "invoice",
          document_type: doc.document_type,
        }))
      );

      setDocuments(
        documents.map((doc) => ({
          id: doc.id,
          key: doc.key,
          name: doc.name,
          url: doc.url,
          type: "document",
          document_type: doc.document_type,
        }))
      );

      setSpreadsheet(
        spreadsheet.map((doc) => ({
          id: doc.id,
          key: doc.key,
          name: doc.name,
          url: doc.url,
          type: "spreadsheet",
          document_type: doc.document_type,
        }))
      );
    } catch (error) {
      console.error("❌ Error fetching documents:", error);
    } finally {
      setIsLoadingDocs(false); // Stop loader
    }
  };

  // const handleAtSearch = (e) => {
  //   const searchValue = e.target.value.toLowerCase();

  //   // Combine all document types into a single array
  //   const allDocsCombined = [
  //     ...documents,
  //     ...contracts,
  //     ...invoices,
  //     ...spreadsheet,
  //   ];

  //   // Filter the combined documents by name
  //   const filtered = allDocsCombined
  //     .filter((doc) => doc.name.toLowerCase().includes(searchValue))
  //     .map(doc => ({
  //       ...doc,
  //       display: doc.name,
  //     }));

  //   setFilteredAtOptions(filtered);
  // };
  const handleAtSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();

    const allDocs = [
      ...documents,
      ...contracts,
      ...invoices,
      ...spreadsheet,
    ].map((doc) => ({
      ...doc,
      display: `${doc.name} (${doc.type})`, // Adds document type as context
      id: doc.id || doc.key || uuidv4(),
    }));

    const filtered = allDocs.filter((doc) =>
      doc.name.toLowerCase().includes(searchValue)
    );

    setFilteredAtOptions(filtered);
  };

  const handleValuesSearch = (e) => {
    const query = e.target.value.toLowerCase();
    // Determine the full list based on the selected object.
    let fullList = [];
    if (selectedObject === "Documents") {
      fullList = documents;
    } else if (selectedObject === "Contracts") {
      fullList = contracts;
    } else if (selectedObject === "Invoices") {
      fullList = invoices;
    } else if (selectedObject === "Spreadsheets") {
      fullList = spreadsheet;
    }
    if (query.trim() === "") {
      // If search query is empty, reset to the full list.
      setFilteredValues(fullList);
    } else {
      // Filter the full list based on the query.
      const filtered = fullList.filter((item) =>
        item.name.toLowerCase().includes(query)
      );
      setFilteredValues(filtered);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setChatInput(value);

    // Hide ContractSearch and clear selected document when input is empty
    if (value.trim() === "") {
      setShowContractSearch(false);
      setSelectedDoc(null);
      setShowAtDropdown(false);
      setSelectedObject(null); // Clear selected object so that all documents appear
    }

    // Trigger fetch when user types "/" (forward slash)
    if (value.endsWith("/")) {
      fetchAllDocuments(); // Call API only when "/" is typed
      setShowObjects(true);
      setFilteredObjects(Object.keys(objectOptions)); // Show top-level objects
    } else {
      setShowObjects(false);
    }

    // Trigger "@" dropdown
    if (value.endsWith("@")) {
      fetchAllDocuments();
      let options = [];
      if (selectedObject) {
        // Show values for the selected object only
        if (selectedObject === "Contracts") {
          options = contracts.map((doc) => ({ ...doc, display: doc.name }));
        } else if (selectedObject === "Invoices") {
          options = invoices.map((doc) => ({ ...doc, display: doc.name }));
        } else if (selectedObject === "Spreadsheets") {
          options = spreadsheet.map((doc) => ({ ...doc, display: doc.name }));
        }
      } else {
        // Combine all document types
        options = [...documents, ...contracts, ...invoices].map((doc) => ({
          ...doc,
          display: `${doc.name}`,
        }));
      }
      setFilteredAtOptions(options);
      setShowAtDropdown(true);
    } else {
      setShowAtDropdown(false);
    }
  };
  const getContextualHint = (type) => {
    switch (type.toLowerCase()) {
      case "invoice":
        return "Ask about due dates, amounts, or line items...";
      case "contract":
        return "Ask about key terms, parties, or expiry clauses...";
      case "spreadsheet":
        return "Ask about summary, trends, or specific columns...";
      case "document":
        return "Ask for summary, insights, or specific sections...";
      default:
        return "Type your question...";
    }
  };

  const getSingular = (obj) => {
    if (obj === "Contracts") return "Contract";
    if (obj === "Invoices") return "Invoice";
    if (obj === "Spreadsheets") return "Spreadsheet";
    return obj;
  };

  const handleObjectSelection = (obj) => {
    // Remove the trailing "/" from the input and append the object name with " : "
    setChatInput((prev) => prev.slice(0, -1) + obj + " : ");
    setShowObjects(false);
    setSelectedObject(obj);

    setTimeout(() => {
      let values = [];
      if (obj === "Documents") {
        values = [...documents];
      } else if (obj === "Contracts") {
        values = [...contracts];
      } else if (obj === "Invoices") {
        values = [...invoices];
      } else if (obj === "Spreadsheets") {
        values = [...spreadsheet];
      }
      setFilteredValues(values);
      setShowValues(true);
    }, 100);
  };

  const handleValueSelection = (val) => {
    if (typeof val === "object") {
      setSelectedDoc(val);
      setContractKey(val.key || val.id);
      setContractUrl(val.url);
      setdocumentType(val.type || val.document_type);
      setselectedDocumentName(val.name);

      if (!selectedObject) {
        const typeMap = {
          document: "Documents",
          contract: "Contracts",
          invoice: "Invoices",
          spreadsheet: "Spreadsheets",
        };
        setSelectedObject(typeMap[val.type] || null);
      }

      setChatInput("");
      setShowValues(false);
    }
  };

  const handleAtSelection = (doc) => {
    setSelectedDoc(doc);
    setContractKey(doc.key || doc.id);
    setContractUrl(doc.url);
    setdocumentType(doc.type || doc.document_type);
    setselectedDocumentName(doc.name);
    setChatInput((prev) => prev.slice(0, -1)); // Remove "@" from input
    setShowAtDropdown(false);

    const capitalizedType =
      doc.type === "document"
        ? "Documents"
        : doc.type.charAt(0).toUpperCase() + doc.type.slice(1) + "s";

    setSelectedObject(capitalizedType);
  };

  const dropdownValuesRef = useRef(null);

  useEffect(() => {
    // Hide dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (
        dropdownValuesRef.current &&
        !dropdownValuesRef.current.contains(event.target)
      ) {
        setShowValues(false);
      }
    };

    // Hide dropdown when Backspace is pressed
    const handleKeyDown = (event) => {
      if (event.key === "Backspace") {
        setShowValues(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // Handle document selection
  const handleDocumentSelect = (doc) => {
    setContractKey(doc.key); // Store the selected document key
    setContractUrl(doc.url);
    setdocumentType(doc.document_type);
    setselectedDocumentName(doc.name);

    setSelectedDoc(doc); // Store the selected document
    setShowContractSearch(false); // Hide ContractSearch
  };

  useEffect(() => {
    const firstName =
      localStorage.getItem("firstName") || localStorage.getItem("first_name");
    const lastName =
      localStorage.getItem("lastname") || localStorage.getItem("last_name");
    const email = localStorage.getItem("email");

    setUser({
      firstName,
      lastName,
      email,
    });
  }, []);

  const initiateNewChat = async () => {
    try {
      const response = await api.post(`api/v1/copilot/new-chat/`, {});

      if (response.data.chat_id) {
        setChatId(response.data.chat_id);
        setIsNewSession(true);
      } else if (
        response.data.msg === "You already have a recent chat session."
      ) {
        // Fallback: Fetch the latest active chat session
        const activeChats = await api.get(`api/v1/copilot/chats/`);
        const latestChat = activeChats.data?.chat_sessions?.[0]; // or use a better filter
        if (latestChat?.id) {
          setChatId(latestChat.id);
          setIsNewSession(false);
          toast.info("Resuming your recent chat");
        } else {
          throw new Error("No recent chat found");
        }
      } else {
        throw new Error("Chat ID not received");
      }
    } catch (error) {
      toast.error("Failed to start a new chat. Please try again.");
    }
  };

  const effectRun = useRef(false);
  const containerRef = useRef(null);
  const inputRef = useRef(null);

  // useEffect(() => {
  //   if (!effectRun.current) {
  //     initiateNewChat();
  //     effectRun.current = true;
  //   }
  // }, []);
  const [isNewSession, setIsNewSession] = useState(false);
  const handleNewChat = () => {
    setIsOpen(false);
    setChatId(null);
    setSelectedChatHistory([]);
    setIsPromptChatVisible(false);
    setChatInput("");
    setSelectedDoc(null);
    setselectedDocumentName("");
    setContractKey(null);
    setContractUrl(null);
    setdocumentType(null);
    setPromptAction("");
    // initiateNewChat();
    if (!isNewSession) {
      setIsNewSession(true);
    }
  };

  useEffect(() => {
    setIsNewSession(true);
  }, []);
  useEffect(() => {}, [isNewSession]);

  // Create a ref to track if a new chat is already being initiated
  const newChatInitiatedRef = useRef(false);

  // Effect to trigger a new chat if needed.
  useEffect(() => {
    if (isNewSession && !chatId && !newChatInitiatedRef.current) {
      newChatInitiatedRef.current = true;
      initiateNewChat();
    }
  }, [isNewSession, chatId]);

  // When chatId is successfully updated, reset the ref to allow future initiations if needed.
  useEffect(() => {
    if (chatId) {
      newChatInitiatedRef.current = false;
    }
  }, [chatId]);

  const handleCopilotButton = () => {
    setChatId(null);
    setSelectedChatHistory([]);
    setIsPromptChatVisible(false);
    setChatInput("");
    setSelectedDoc(null);
    setselectedDocumentName("");
    setContractKey(null);
    setContractUrl(null);
    setdocumentType(null);
    setPromptAction("");
    initiateNewChat();
    if (!isNewSession) {
      setIsNewSession(true);
    }
  };
  useEffect(() => {
    setSelectedDoc(null);
    setselectedDocumentName("");
  }, []);

  const handleSendMessage = async () => {
    let promptToSend = chatInput.trim();

    if (!promptToSend) {
      if (selectedDoc) {
        promptToSend = "summary";
      } else {
        toast.error("Please enter a prompt!");
        return;
      }
    }

    // 👇 Only create chatId once if needed
    let finalChatId = chatId;
    if (!finalChatId) {
      try {
        const response = await api.post(`api/v1/copilot/new-chat/`, {});
        finalChatId = response.data.chat_id;
        setChatId(finalChatId);
      } catch (error) {
        console.error("❌ Failed to start new chat:", error);
        toast.error("Unable to start a chat session.");
        return;
      }
    }

    // ✅ Let PromptChat handle WebSocket using these states
    setChatInput(promptToSend); // Update UI to reflect the fallback

    setIsNewSession(true);
    setIsPromptChatVisible(true);
  };

  useEffect(() => {}, [progress]);

  const showPopup = (title, message) => {
    setPopupTitle(title);
    setPopupMessage(message);
    setPopupVisible(true);
  };

  const closePopup = () => {
    setPopupVisible(false);
  };

  const toggleModal = () => {
    if (!token) {
      showPopup("Session Expired", "Session expired. Please log in again.");
      return;
    }
    setIsModalOpen((prev) => !prev);
  };

  const handleUploadSuccess = () => {
    toggleModal();
  };

  const handleCloseModal = () => {
    toggleModal();
  };

  const handleSearch = () => {};

  const filteredContracts = useMemo(() => {
    if (!files || files.length === 0) return [];
    return files.filter((file) => {
      if (!file?.pdf_name) return false;
      return file.pdf_name.toLowerCase().includes(searchQuery.toLowerCase());
    });
  }, [files, searchQuery]);
  const filteredData = useMemo(() => {
    const normalizedQuery = searchQuery
      .trim()
      .replace(/\s+/g, " ")
      .toLowerCase();

    if (!normalizedQuery) return [...folders, ...files];

    return [...folders, ...files].filter((item) =>
      (item.name || "").toLowerCase().includes(normalizedQuery)
    );
  }, [folders, files, searchQuery]);

  // Function that clears the clickedCardIndex if the click is outside and the chat input is empty
  const handleClickOutside = (event) => {
    // setIsOpen(false);
    // Check if the click happened outside of our container
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      // Only reset the active card index if the chat input is empty (after trimming whitespace)
      if (chatInput.trim() === "") {
        setClickedCardIndex(null);
      }
    }
  };

  // Attach the event listener to detect clicks outside of the container
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [chatInput]); // re-run effect if chatInput changes

  // Define your placeholder text (should match your textarea placeholder)
  const placeholderText =
    "How can I help? Type your question or choose a prompt";

  // 1) If user has typed something, calculate based on input length.
  //    Otherwise, base it on the placeholder text length.
  const computedWidth =
    chatInput.trim().length > 0
      ? chatInput.length * 10
      : placeholderText.length * 10;

  // 2) Enforce a minimum width (e.g., 200px) and a maximum width (e.g., 600px)
  const dynamicWidth = Math.min(400, Math.max(300, computedWidth));

  // When user clicks "Summarize Document" from modal
  const [SummarizeDocKey, setSummarizeDocKey] = useState("");
  const [SummarizeDocUrl, setSummarizeDocUrl] = useState("");
  const [SummarizeDocType, setSummarizeDocType] = useState("");
  const [documentUrl, setDocumentUrl] = useState("");
  const [promptAction, setPromptAction] = useState("");

  // const [documentType, setDocumentType] = useState("");
  const handleSummarizeDocumentFromModal = ({
    contractKey,
    contractUrl,
    docType,
  }) => {
    // Save doc info to local state
    setSummarizeDocKey(contractKey);

    setSummarizeDocUrl(contractUrl);
    setSummarizeDocType(docType);
    setPromptAction("summarize");
    setIsPromptChatVisible(true);

    setIsModalOpen(false);
  };

  const handleUserInteraction = () => {
    if (!isNewSession) {
      setIsNewSession(true);
    }
  };

  return (
    <div className="container-ai-copilot-custom">
      <header className="flex justify-between items-center w-full h-[60px] bg-[#fff] border border-black/10 pr-4">
        {/* 
        <button
          className="flex items-center ml-[200px] cursor-pointer bg-transparent border-none" onClick={handleCopilotButton}
        >

          <h2
            className="mr-4"
            style={{
              color: "#000",
              fontFamily: "Outfit, sans-serif",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "normal",
            }}
          >
            AI Copilot
          </h2>
        </button> */}

        <div
          className={`${
            isMenuOpen ? "ml-12" : "ml-0"
          } AI-CP-ChatHistoryContainer  flex gap-4`}
        >
          <div className="relative group">
            <button
              // className="w-[44px] h-[36px] rounded-[6px] border border-[rgba(0,0,0,0.1)] bg-white p-[8px_12px] gap-[8px] shadow-[1px_3px_6px_rgba(0,0,0,0.1),5px_10px_11px_rgba(0,0,0,0.09),11px_23px_15px_rgba(0,0,0,0.05),20px_41px_18px_rgba(0,0,0,0.01),31px_64px_20px_rgba(0,0,0,0)] flex items-center justify-center"
              className="newChat-button"
              onClick={handleNewChat}
            >
              <img
                src="/newChat-icon.svg"
                alt="New Chat Icon"
                className="newChat-icon"
              />
            </button>

            {/* Tooltip Below */}
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 z-[1100] px-3 py-1 bg-black text-white text-xs rounded-lg shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
              Start New Chat
              {/* Upward Arrow */}
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-black rotate-45"></div>
            </div>
          </div>

          <button className="chat-historyBtn" onClick={toggleChatHistory}>
            <img src="/chatHistory-button.svg" alt="Forward arrow" />
          </button>
          <ChatHistory
            isOpen={isOpen}
            chatHistory={chatHistory}
            setChatHistory={setChatHistory}
            onSelectChat={handleChatSelection}
            onNewChat={handleNewChat}
            isLoadingChatHistory={isLoadingChatHistory}
            activeChatId={chatId}
            fetchChatHistory={fetchChatHistory} // ✅ pass it in
          />
        </div>
      </header>

      {/* Render Menu but hide it */}
      <div style={{ display: "none" }}>
        <Menu isOpen={isMenuOpen} setDisplayName={setDisplayName} />
      </div>

      {isPromptChatVisible ? (
        <>
          <PromptChat
            chatInput={chatInput}
            selectedDocs={selectedDoc}
            chatId={chatId}
            isNewSession={isNewSession}
            onMessagesUpdated={(updatedArray) =>
              setSelectedChatHistory(updatedArray)
            }
            key={chatId}
            documentKey={contractKey}
            documentUrl={contractUrl}
            documentType={documentType}
            documentId={selectedDoc?.id}
            selectedDocumentName={selectedDocumentName}
            enrichedPrompt={enrichedPrompt}
            isLoadingResponse={isLoadingResponse}
            finalResponse={finalResponse || ""}
            generatedQuestions={generatedQuestions || []}
            isMenuOpen={isMenuOpen}
            onNewChat={handleNewChat}
            initialMessages={selectedChatHistory}
            action={promptAction}
            SummarizeDocKey={SummarizeDocKey}
            SummarizeDocUrl={SummarizeDocUrl}
            SummarizeDocType={SummarizeDocType}
            isChatHistoryOpen={isOpen}
          />
        </>
      ) : (
        // <div className={`ai-container ${isMenuOpen ? 'menu-open' : ''}`} >
        //   <div className={`copilot-page ${isMenuOpen ? 'reduced-width' : ''}`} >
        <div className="upload-mainpage flex justify-center items-center">
          {/* style={{
            background: 'linear-gradient(130.93deg, rgba(139, 85, 221, 0.44) 10.67%, rgba(187, 66, 174, 0.44) 85.46%)'
          }} */}

          <div
            className={`${isMenuOpen ? "ml-36" : "ml-12"} mainAI-container `}
          >
            <div
              className="AI-Container"
              style={{
                transform: isOpen ? "translateX(7rem)" : "translateX(0)",
                transition: "transform 0.3s ease",
              }}
            >
              <div className="topContainer inline-flex flex-col justify-center items-center">
                <h6>
                  Hi{" "}
                  {(displayName || "")
                    .split(" ")
                    .map((name) => name.charAt(0).toUpperCase() + name.slice(1))
                    .join(" ")}
                </h6>

                <span>What Can I Help You With Today?</span>
                <p>
                  Type your request below with one of <br />
                  these suggestions.
                </p>
              </div>

              <div className="secondContainer">
                <div ref={containerRef} className="card_container">
                  <div
                    className={`card ${clickedCardIndex === 0 ? "active" : ""}`}
                    onClick={() =>
                      handleCardClick("Summarize the data from Contract", 0)
                    }
                  >
                    <img src={summarizeIcon} alt="Summarize Icon" />
                    <p>Summarize the data from Contract</p>
                  </div>

                  <div
                    className={`card ${clickedCardIndex === 1 ? "active" : ""}`}
                    onClick={() =>
                      handleCardClick("Extract payment terms from Invoice", 1)
                    }
                  >
                    <img src={InvoiceIcon} alt="Invoice Icon" />
                    <p>Extract payment terms from Invoice</p>
                  </div>

                  <div
                    className={`card ${clickedCardIndex === 2 ? "active" : ""}`}
                    onClick={() =>
                      handleCardClick("Extract Due date of the Invoice", 2)
                    }
                  >
                    <img src={SpreadsheetIcon} alt="spreadsheet Icon" />
                    <p>Extract Due date of the Invoice</p>
                  </div>
                </div>
                <div className="explorePrompt">
                  <button
                    onClick={() => {
                      setIsPromptModalOpen(true);
                      if (!isNewSession) {
                        setIsNewSession(true);
                      }
                    }}
                  >
                    <span>Explore Prompts</span>
                    <img src={arrowForward} alt="Forward arrow" />
                  </button>

                  {isPromptModalOpen && (
                    <div
                      className="AI-CP-modal-overlay"
                      onClick={() => setIsPromptModalOpen(false)}
                    ></div>
                  )}

                  <ExplorePrompt
                    isOpen={isPromptModalOpen}
                    onClose={() => setIsPromptModalOpen(false)}
                    onSelectPrompt={handlePromptSelection}
                  />
                </div>
              </div>

              <div className="thirdContainer">
                <div className="inputFieldWrapper relative">
                  <div
                    className={`AI-chat-input-section ${
                      isChatActive || inputValue.trim() !== "" ? "active" : ""
                    }`}
                  >
                    <div className="ml-1">
                      <button
                        className={`uploadButton ${
                          isButtonClicked ? "active-shadow" : ""
                        }`}
                        onClick={() => fileInputRef.current.click()}
                      >
                        <img
                          src={UploadIcon}
                          alt="Upload Icon"
                          className="w-6 h-6"
                        />
                      </button>

                      <input
                        ref={fileInputRef}
                        type="file"
                        multiple
                        style={{ display: "none" }}
                        accept=".pdf,.xls,.xlsx,.csv,.txt,.doc,.jpeg,.jpg,.png,.webp,.bmp"
                        onChange={handleUploadFileChange}
                      />

                      {isModalOpen && (
                        <div
                          className="AI-CP-modal-overlay"
                          onClick={() => setIsModalOpen(false)}
                        ></div>
                      )}

                      <DocumentUploadModal
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        type="document"
                        onSummarizeDocument={handleSummarizeDocumentFromModal}
                      />
                      <UploadModal
                        isOpen={isUploadModalOpen}
                        onClose={() => setIsUploadModalOpen(false)}
                        onUploadSuccess={() => {
                          setIsUploadModalOpen(false);
                          fetchAllDocuments();
                        }}
                        type={"ai-copilot"}
                        file={uploadFiles}
                      />
                    </div>

                    <div className="inutSection">
                      <div
                        className="searchContent"
                        style={{
                          width:
                            showContractSearch || selectedDoc ? "auto" : "100%",

                          alignItems: "center",
                        }}
                      >
                        {selectedDoc && (
                          <div className="selected-file-pill">
                            <span
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {`${
                                selectedDoc.type.charAt(0).toUpperCase() +
                                selectedDoc.type.slice(1)
                              } : ${
                                selectedDoc.name.length > 30
                                  ? selectedDoc.name.slice(0, 30) + "..."
                                  : selectedDoc.name
                              }`}
                            </span>{" "}
                            <button
                              onClick={() => {
                                setSelectedDoc(null);
                                setPromptChatInput("");
                              }}
                            >
                              ×
                            </button>
                          </div>
                        )}

                        <textarea
                          ref={inputRef}
                          className={`AI-chat-input resize-none overflow-auto placeholder:text-[#71717A] placeholder:font-outfit placeholder:text-[15px] placeholder:font-normal`}
                          placeholder={
                            isLoadingResponse
                              ? "Copilot is responding..."
                              : selectedDoc
                              ? `${getContextualHint(selectedDoc.type)}`
                              : "How can I help? Type your question or choose a prompt"
                          }
                          value={chatInput}
                          onClick={handleUserInteraction}
                          onChange={handleInputChange}
                          onFocus={handleFocus}
                          onBlur={handleBlur}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleSendMessage();
                            }
                          }}
                          rows={1}
                          style={{
                            width: `${dynamicWidth}px`,

                            maxHeight: "150px",

                            borderRadius: "6px",
                            overflowY: "auto",
                            overflowX: "hidden",
                            transition: "width 0.2s ease-in-out",
                          }}
                        />
                        {showObjects && (
                          <div className="AI-dropdown-wrapper">
                            <div className="AI-dropdown-container">
                              <h1 className="AI-dropdown-heading">
                                Document Types
                              </h1>
                              <ul className="AI-dropdown-menu AI-dropdown-objects">
                                {[
                                  "Documents",
                                  "Contracts",
                                  "Invoices",
                                  "Spreadsheets",
                                ].map((obj) => (
                                  <li
                                    key={obj}
                                    className="AI-dropdown-item"
                                    onClick={() => handleObjectSelection(obj)}
                                  >
                                    {objectIcons[obj] && (
                                      <span className="AI-dropdown-icon">
                                        {objectIcons[obj]}
                                      </span>
                                    )}
                                    <span className="AI-dropdown-text">
                                      {obj}
                                    </span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        )}

                        {showValues && selectedObject && (
                          <div
                            className="dropdown-wrapper-values"
                            ref={dropdownValuesRef}
                          >
                            <div className="dropdown-container-values">
                              <h1 className="dropdown-heading-values">
                                Select {getSingular(selectedObject)}
                              </h1>
                              <div className="AI-values-SearchBox">
                                <img src="/search.svg" alt="search icon" />
                                <input
                                  type="text"
                                  placeholder="Search here"
                                  className="AI-values-SearchBox-input"
                                  onChange={handleValuesSearch}
                                />
                              </div>

                              <div className="dropdown-scrollable">
                                <ul className="dropdown-menu-values">
                                  {filteredValues.length > 0 ? (
                                    filteredValues.map((val, index) => (
                                      <li
                                        key={val.id || index}
                                        className="dropdown-item-values"
                                        onClick={() =>
                                          handleValueSelection(val)
                                        }
                                        title={val.name}
                                      >
                                        <img
                                          src="/ai-object-document-icon.svg"
                                          alt="documents icon"
                                        />
                                        <span>{val.name}</span>
                                      </li>
                                    ))
                                  ) : (
                                    <li className="dropdown-item-values no-data">
                                      No values found
                                    </li>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>
                        )}

                        {showAtDropdown && (
                          <div className="dropdown-wrapper-at">
                            <div className="dropdown-container-at">
                              <h1 className="dropdown-heading-at">
                                Select Document
                              </h1>
                              <div className="dropdown-searchbox-at">
                                <img
                                  src="/search.svg"
                                  alt="search icon"
                                  className="dropdown-search-icon-at"
                                />
                                <input
                                  type="text"
                                  placeholder="Search here"
                                  className="dropdown-search-input-at"
                                  onChange={handleAtSearch}
                                />
                              </div>

                              <div className="dropdown-scrollable-at">
                                <ul className="dropdown-menu-at">
                                  {filteredAtOptions.length > 0 ? (
                                    filteredAtOptions.map((doc) => (
                                      <li
                                        key={doc.id || doc.key || uuidv4()}
                                        className="dropdown-item-at"
                                        onClick={() => handleAtSelection(doc)}
                                        title={doc.display}
                                      >
                                        <img
                                          src="/ai-object-document-icon.svg"
                                          alt={`${doc.type} icon`}
                                          className="dropdown-item-icon-at"
                                        />
                                        <span>{doc.display}</span>
                                      </li>
                                    ))
                                  ) : (
                                    <li className="dropdown-item-at no-data">
                                      No documents found
                                    </li>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="searchDocument flex items-center ml-2">
                          {selectedDoc ? (
                            <button
                              onClick={() => setShowContractSearch(true)}
                            ></button>
                          ) : showContractSearch ? (
                            <div className="ml-0">
                              {selectedPromptSection === "Documents" && (
                                <SearchDocuments
                                  onDocumentSelect={handleDocumentSelect}
                                />
                              )}
                              {selectedPromptSection === "Contracts" && (
                                <ContractSearch
                                  onDocumentSelect={handleDocumentSelect}
                                />
                              )}
                              {selectedPromptSection === "Invoices" && (
                                <SearchInvoice
                                  onDocumentSelect={handleDocumentSelect}
                                />
                              )}
                              {selectedPromptSection === "Spreadsheets" && (
                                <SearchSpreadsheet
                                  onDocumentSelect={handleDocumentSelect}
                                />
                              )}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <button
                        className="AI-CP-chat-button ml-2"
                        onClick={handleSendMessage}
                      >
                        <img
                          src="/send.svg"
                          alt="send logo"
                          className="send-icon"
                          style={{ width: "24px", height: "24px" }}
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
